import { zodSchemes } from '@approvalmax/utils';
import { stringHelpers } from '@approvalmax/utils';
import { standaloneConstants } from 'modules/common/constants';
import { z } from 'zod';

import { messages } from './DescriptionSection.messages';

export const schema = z.object({
    description: zodSchemes.required.textField.string().superRefine((value, ctx) => {
        const cleanedTextLength =
            stringHelpers.cleanHTMLAttributes(standaloneConstants.STANDALONE_EXCLUDED_ATTRIBUTES, value)?.length || 0;

        if (cleanedTextLength > standaloneConstants.REQUEST_DESCRIPTION_MAX_LENGTH) {
            ctx.addIssue({
                code: z.ZodIssueCode.too_big,
                maximum: standaloneConstants.REQUEST_DESCRIPTION_MAX_LENGTH,
                type: 'string',
                inclusive: true,
                message: messages.exceededDescriptionLengthErrorText({
                    maxLength: standaloneConstants.REQUEST_DESCRIPTION_MAX_LENGTH,
                }),
            });
        }
    }),
});
